import { Badge, Typography } from "@mui/material";

interface Props {
  conditionsCount: number;
}

export const ConditionsCollapsedHeader = (props: Props) => {
  const { conditionsCount } = props;
  return (
    <>
      <Typography variant="h6" sx={(theme) => ({ color: theme.palette.text.primary, transform: "rotate(90deg)" })}>
        Conditions
      </Typography>
      <Badge
        sx={(theme) => ({
          color: theme.palette.secondary.main,
          position: "absolute",
          top: "120px",
          left: "32px",
          ".BaseBadge-badge": { backgroundColor: theme.palette.action.selected },
          transition: "1.5s ease",
        })}
        badgeContent={conditionsCount}
      ></Badge>
    </>
  );
};

export default ConditionsCollapsedHeader;
